import { GzRmCompanyStateWidgetWebComponent } from './component/GzRmCompanyStateWidgetWebComponent';

export { GzRmCompanyStateWidgetWebComponent };
